export const workingDays = {
  days: [
    {
      name: {
        label: 'Sunday',
        value: 'sunday',
      },
      is_working: true,
      started_at: '00:00',
      ended_at: '24:00',
    },
    {
      name: {
        label: 'Monday',
        value: 'monday',
      },
      is_working: true,
      started_at: '10:00',
      ended_at: '18:00',
    },
    {
      name: {
        label: 'Tuesday',
        value: 'tuesday',
      },
      is_working: true,
      started_at: '10:00',
      ended_at: '18:00',
    },
    {
      name: {
        label: 'Wednesday',
        value: 'wednesday',
      },
      is_working: true,
      started_at: '10:00',
      ended_at: '18:00',
    },
    {
      name: {
        label: 'Thursday',
        value: 'thursday',
      },
      is_working: true,
      started_at: '10:00',
      ended_at: '18:00',
    },
    {
      name: {
        label: 'Friday',
        value: 'friday',
      },
      is_working: true,
      started_at: '10:00',
      ended_at: '18:00',
    },
    {
      name: {
        label: 'Saturday',
        value: 'saturday',
      },
      is_working: true,
      started_at: '10:00',
      ended_at: '18:00',
    },
  ],
  start_day: {
    label: 'Sunday',
    value: 'sunday',
  },
};
